import React from 'react'
import { useTranslation } from 'react-i18next'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  const { t } = useTranslation()

  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-main-grid">
            <div className="footer-brand-column">
              <div className="footer-logo-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                  className="footer-brand-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </g>
                </svg>
                <span className="section-subtitle footer-brand-name">
                  {t('footer.brandName')}
                </span>
              </div>
              <p className="footer-description section-content">
                {t('footer.tagline')}
              </p>
            </div>
            <div className="footer-cta-column">
              <h3 className="footer-column-title section-subtitle">
                {t('footer.getApp')}
              </h3>
              <p className="footer-cta-text section-content">
                {t('footer.getAppDesc')}
              </p>
              <div className="footer-app-buttons">
                <a href="https://apps.apple.com/jp/app/%E3%81%BE%E3%81%A1%E3%81%AE%E6%B0%97%E3%81%A5%E3%81%8D/id6759237613"
                   target="_blank"
                   rel="noreferrer noopener"
                >
                  <div
                    aria-label="Download on App Store"
                    className="footer-app-btn"
                  >
                    <div className="footer-app-btn-inner">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        className="footer-btn-icon"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="5"
                            y="2"
                            rx="2"
                            ry="2"
                            width="14"
                            height="20"
                          ></rect>
                          <path d="M12 18h.01"></path>
                        </g>
                      </svg>
                      <div className="footer-app-btn-text">
                        <span className="footer-app-btn-label">
                          {t('footer.appStoreLabel')}
                        </span>
                        <span className="footer-app-btn-brand">
                          {t('footer.appStore')}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=place.point.localnote"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    aria-label="Get it on Google Play"
                    className="footer-thq-footer-app-btn-elm2 footer-app-btn"
                  >
                    <div className="footer-app-btn-inner">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        className="footer-btn-icon"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="5"
                            y="2"
                            rx="2"
                            ry="2"
                            width="14"
                            height="20"
                          ></rect>
                          <path d="M12 18h.01"></path>
                        </g>
                      </svg>
                      <div className="footer-app-btn-text">
                        <span className="footer-app-btn-label">{t('footer.googlePlayLabel')}</span>
                        <span className="footer-app-btn-brand">
                          {t('footer.googlePlay')}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <div className="footer-legal-links">
              <a
                href="https://point.place/privacy-policy"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className="footer-thq-footer-legal-link-elm1 footer-legal-link section-content">
                  <span>{t('footer.privacy')}</span>
                </div>
              </a>
              <a href="https://point.place/terms">
                <div className="footer-legal-link section-content">
                  <span>{t('footer.terms')}</span>
                </div>
              </a>
            </div>
            <p className="footer-copyright section-content">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: no-preference) {
.footer-social-icon, .footer-nav-link, .footer-app-btn {
  will-change: transform;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<script defer data-name="footer-interactivity">
(function(){
  const footerIcons = document.querySelectorAll(".footer-social-icon")

  footerIcons.forEach((icon) => {
    icon.addEventListener("mouseenter", () => {
      const svg = icon.querySelector("svg")
      if (svg) {
        svg.style.transition = "transform 0.3s ease"
        svg.style.transform = "scale(1.1)"
      }
    })

    icon.addEventListener("mouseleave", () => {
      const svg = icon.querySelector("svg")
      if (svg) {
        svg.style.transform = "scale(1)"
      }
    })
  })

  const appButtons = document.querySelectorAll(".footer-app-btn")
  appButtons.forEach((btn) => {
    btn.addEventListener("mousedown", () => {
      btn.style.transform = "scale(0.96)"
    })
    btn.addEventListener("mouseup", () => {
      btn.style.transform = "scale(1)"
    })
    btn.addEventListener("mouseleave", () => {
      btn.style.transform = "scale(1)"
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
